import {component, EntityData, transientIdentifier} from "@fedeltapointofsale/data-client";
import {CompositeProductComponentPlgData, CompositeProductComponentProductLineData} from "./composite-product.data";

export class CompositeProductComponentSearchData extends EntityData<CompositeProductComponentSearchData> {
    @component productLine: CompositeProductComponentProductLineData;
    @component plg: CompositeProductComponentPlgData;

    @transientIdentifier
    get id(): string {
        return this.productLine && this.productLine.sellableId ? "productLine_" + this.productLine.sellableId : "plg_" + this.plg.plgId;
    }

    get name(): string {
        return this.productLine && this.productLine.sellableId ? this.productLine.name : this.plg.name;
    }

    get descriptor(): string {
        return this.productLine && this.productLine.sellableId ? this.productLine.name : "[" + this.plg.name + "]";
    }
}
